<!--
 * @Author       : Lobin
 * @Date         : 2022-06-23 23:15:42
 * @LastEditors  : Lobin
 * @Description  : 
 * @LastEditTime : 2022-06-24 16:17:21
-->
<template>
  <div class="search-list">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="用户名">
        <el-input v-model="formInline.username" placeholder="用户名"></el-input>
      </el-form-item>
      <el-form-item label="IP">
        <el-input v-model="formInline.ip" placeholder="IP"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList" :loading="loading">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="search-list-data" v-loading="loading">
        <el-table :data="tableData" stripe style="width: 100%" size="medium" border>
            <el-table-column type="index" label="#" width="50">
            </el-table-column>
            <el-table-column type="expand">
            <template slot-scope="props">
              <div class="grant-list">
                  <p style="word-wrap: break-word;">{{ props.row.remarks}}</p>
              </div>
            </template>
          </el-table-column>
            <el-table-column prop="type" label="类型">
            </el-table-column>
            <el-table-column prop="ip" label="IP">
            </el-table-column>
            <el-table-column prop="username" label="用户名"> </el-table-column>
            <el-table-column prop="result" label="结果">
              <template slot-scope="props">
                <el-tag v-if="props.row.result === '成功'">{{ props.row.result }}</el-tag>
                <el-tag type="danger" v-else>{{ props.row.result }}</el-tag>
              </template>
              
            </el-table-column>
            <el-table-column prop="ctime" label="创建时间"> </el-table-column>
            <el-table-column prop="remarks" label="说明">
              <template slot-scope="props">
                <div style="width:90px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                  {{ props.row.remarks }}
                </div>
              </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="pager">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :total="pager.total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      formInline: {
        username: "",
        ip: "",
      },
      tableData: [],
      pager: {
        page: 1,
        pageSize: 20,
        total: 0,
      },
      loading: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    ...mapActions({
      getAdminLogs: 'user/getAdminLogs',
    }),
    async getList() {
      this.loading = true;
      const data = await this.getAdminLogs({
        ...this.formInline,
        page: this.pager.page,
      });
      this.tableData = data.docs;
      this.pager = {
        page: data.page,
        pageSize: data.limit,
        total: data.total,
      };
      this.loading = false;
    },
    handleCurrentChange(current) {
      this.pager.page = current;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.btns {
    margin-bottom: 10px;
}
.pager {
  text-align:center;
  margin-top: 10px;
}
</style>
